import axios from "axios";
import { Message, MessageBox } from "element-ui"; //element-ui提示信息的组件
import store from "@/store";
import serviceBaseUrl from "@/utils/baseurl";

// 创建axios实例
const service = axios.create({
    baseURL: serviceBaseUrl, // 此处的baseURL 可在config文件夹的两个env文件修改 尽量做到一键部署
    timeout: 10000, // 请求超时时间
    withCredentials: true,
    // transformRequest: [
    //     function(data) {
    //         data = qs.stringify(data);
    //         return data;
    //     }
    // ],
    headers: {
        // "Content-Type": "application/x-www-form-urlencoded"
        "Content-Type": "application/json; charset=utf-8"
    }
});

// request拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            // config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
            config.headers.common["Authorization"] =
                store.getters.token || sessionStorage.getItem("token");
            //让每个请求携带自定义token 请根据实际情况自行修改
        }
        if (sessionStorage.getItem('token') != null) {
            config.headers.common['X-Token'] = sessionStorage.getItem('token');
        }
        return config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);

// response 拦截器
service.interceptors.response.use(
    // eslint-disable-next-line consistent-return
    response => {
        // console.log(response);

        /**
         * 可结合自己业务进行修改
         */

        // if (res.code !== 20000) {
        //     Message({
        //         message: res.message,
        //         type: "error"
        //     });

        //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        //     if (
        //         res.code === 50008 ||
        //         res.code === 50012 ||
        //         res.code === 50014
        //     ) {
        //         MessageBox.confirm(
        //             "你已被登出，可以取消继续留在该页面，或者重新登录",
        //             "确定登出",
        //             {
        //                 confirmButtonText: "重新登录",
        //                 cancelButtonText: "取消",
        //                 type: "warning"
        //             }
        //         ).then(() => {
        //             store.dispatch("FedLogOut").then(() => {
        //                 location.reload(); // 为了重新实例化vue-router对象 避免bug
        //             });
        //         });
        //     }
        //     return Promise.reject("error");
        // }

        // return response.data;
        if (response.status === 200) {
            // console.log(!response.data.success && response.data.errorCode && response.data.data);
            if (!response.data.success) {
                if (
                    response.data.errorCode === "403" ||
                    response.data.errorCode === "401"
                ) {
                    MessageBox.confirm(response.data.errorMsg, {
                        confirmButtonText: "重新登录",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            store.dispatch("FedLogOut").then(() => {
                                // location.reload(); // 为了重新实例化vue-router对象 避免bug
                            });
                        })
                        .catch(() => {});
                    return Promise.reject("error");
                }
                if (
                    response.data.errorCode === "504" ||
                    response.data.errorCode === "404"
                ) {
                    Message.error({ message: "服务器被吃了⊙﹏⊙∥" });
                } else if (response.data.errorCode === "400") {
                    Message.error({ message: response.data.errorMsg });
                } else if (response.data.errorCode === "500") {
                    Message.error({ message: response.data.errorMsg });
                }
            }
            return response.data;
        }

        // return response; // 正式业务具体修改
    }
    // 以上error开发的时候具体业务具体处理↑
);

export default service;
